import React, { useEffect, useState } from "react";
import Lottie from "lottie-react";
import ProcessLottie from "../lottiefiles/processing.json";
import ErrorLottie from "../lottiefiles/error.json";
import { servicePost } from "../../helper/api";
import { setUser } from "../../redux/features/userSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import InputField from "../UIComponents/InputField";
import Button from "../UIComponents/Button";
import { jwtDecode } from "jwt-decode";

const AuthLogin = () => {
  const [loginToken, setLoginToken] = useState();
  const [phoneVerified, setPhoneVerified] = useState(false);
  const [isPhoneLoading, setIsPhoneLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [authCheckComplete, setAuthCheckComplete] = useState(true);
  const [errorMessage, setErrorMessage] = useState();

  const decodeToken = (token) => {
    try {
      const decoded = jwtDecode(token);
      console.log(decoded); // Contains user information
      return decoded;
    } catch (error) {
      console.error("Invalid token", error);
      return null;
    }
  };

  const location = useLocation();
  const user = location?.state;

  // get AuthToken from localStorage
  const authToken = loginToken;
  const notification = "";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    phoneNumber: "",
  });
  const { phoneNumber } = formData;

  // Error Validation
  const [errors, setErrors] = useState({
    phoneNumber: "",
  });

  const errorMessages = {
    phoneNumber: "Phone number is required",
    phoneValidation: "Enter valid phone number",
  };

  // get All InputValues
  const inputEventHandler = (event) => {
    const { name, value } = event.target;

    let formattedValue = value;

    if (name === "phoneNumber") {
      // Remove all non-numeric characters
      const numericValue = value.replace(/\D/g, "");
      const limitedNumericValue = numericValue.slice(0, 10);

      // Format the number as xxx-xxx-xxxx
      if (limitedNumericValue.length > 3 && limitedNumericValue.length <= 6) {
        formattedValue = `${limitedNumericValue.slice(
          0,
          3
        )}-${limitedNumericValue.slice(3)}`;
      } else if (limitedNumericValue.length > 6) {
        formattedValue = `${limitedNumericValue.slice(
          0,
          3
        )}-${limitedNumericValue.slice(3, 6)}-${limitedNumericValue.slice(
          6,
          10
        )}`;
      } else {
        formattedValue = limitedNumericValue;
      }
    }

    setFormData((preVal) => {
      const updatedProfileData = {
        ...preVal,
        [name]: formattedValue,
      };

      return updatedProfileData;
    });
  };

  // Signup Request handler
  const signupReqHandler = async () => {
    try {
      const requiredFields = ["phoneNumber"];
      const newErrors = {};

      requiredFields.forEach((field) => {
        if (!formData[field] || !formData[field].trim()) {
          newErrors[field] = errorMessages[field];
        }
      });

      if (Object.keys(newErrors).length > 0) {
        setErrors((prevErrors) => ({ ...prevErrors, ...newErrors }));
        return;
      }

      //Check Number Valid
      if (phoneNumber?.length < 12) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          phoneNumber: errorMessages.phoneValidation,
        }));
        return;
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          phoneNumber: "",
        }));
      }

      setIsPhoneLoading(true);
      const loginUser = await servicePost(
        "auth/addPhoneNumber",
        {
          email: user?.email,
          phonenumber: phoneNumber,
        },
        notification,
        authToken
      );

      if (loginUser.message == "SUCCESS") {
        setIsPhoneLoading(false);
        setIsError(false);
        localStorage.setItem("user", JSON.stringify(loginUser?.data));
        localStorage.setItem("token", loginUser?.token);
        dispatch(
          setUser({
            userInfo: loginUser?.data,
            token: loginUser?.token,
          })
        );

        if (
          loginUser?.data.enableOn == true ||
          loginUser?.data.enableOn == "true"
        ) {
          navigate("/enter-twofa");
        } else if (
          (loginUser?.data.enableOn == false ||
            loginUser?.data.enableOn == "false" ||
            loginUser?.data.enableOn == null) &&
          (loginUser?.data.twoFaRequest == true ||
            loginUser?.data.twoFaRequest == "true")
        ) {
          navigate("/enter-twofa");
        } else {
          navigate("/");
        }
      }
    } catch (error) {
      setIsPhoneLoading(false);
      setErrorMessage(error.response?.data.message);
      // setErrorMessage(error.response?.data.message);
      setTimeout(() => {
        setErrorMessage("");
      }, 5000);
      return;
    }
  };

  const SignupWithGoogle = async () => {
    try {
      const loginUser = await servicePost(
        "auth/signInWithGoogle",
        {
          email: user?.email,
          fullname: user?.name,
          profileImage: user?.picture,
          emailverified: user?.email_verified,
        },
        {}
        //csrfTokenState
      );

      console.log("data", loginUser);
      if (loginUser.data.phone == null) {
        setLoginToken(loginUser?.token);
        setPhoneVerified(false);
      } else {
        if (loginUser.message == "SUCCESS") {
          setPhoneVerified(true);
          setIsError(false);
          localStorage.setItem("user", JSON.stringify(loginUser?.data));
          localStorage.setItem("token", loginUser?.token);
          dispatch(
            setUser({
              userInfo: loginUser?.data,
              token: loginUser?.token,
            })
          );

          if (
            loginUser?.data.enableOn == true ||
            loginUser?.data.enableOn == "true"
          ) {
            navigate("/enter-twofa");
          } else if (
            (loginUser?.data.enableOn == false ||
              loginUser?.data.enableOn == "false" ||
              loginUser?.data.enableOn == null) &&
            (loginUser?.data.twoFaRequest == true ||
              loginUser?.data.twoFaRequest == "true")
          ) {
            navigate("/enter-twofa");
          } else {
            navigate("/");
          }
        }
      }
    } catch (error) {
      setIsError(true);
      console.log("error", error);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setAuthCheckComplete(false);
    }, 2000);
  }, [user]);

  useEffect(() => {
    if (user) {
      SignupWithGoogle();
    }
  }, [user]);

  return (
    <div className="login-main-wrapper auth-login-main-wrapper">
      <div className="login-main-wrap auth-login-main-wrap  container">
        {authCheckComplete ? (
          <>
            <div className="process-loading-gif">
              <Lottie animationData={ProcessLottie} loop={true} />
            </div>
            <h3> Account Verification in Progress </h3>

            <p>
              Thank you for signing up with Google! We're verifying your account
              details and setting things up for you. This may take a moment.
              Please wait while we process your information. Once completed,
              you'll be redirected to your dashboard automatically.
            </p>
          </>
        ) : user && !phoneVerified ? (
          <>
            <div className="phone-number-wrapper">
              <h3>Provide phone number to proceed </h3>

              <div className="login-form-main-wrap">
                <div className="login-option">
                  <form autoComplete="off">
                    <div className="phone-number-input-box">
                      <div className="number-flag-box-wrap">
                        <img src="./assets/icons/canada-flag.png" alt="icon" />
                        <p> +1 </p>
                      </div>
                      <InputField
                        extraClass={
                          errors?.phoneNumber
                            ? `error-msg`
                            : phoneNumber
                            ? "active"
                            : ""
                        }
                        type="text"
                        name="phoneNumber"
                        id="phoneNumber"
                        label={
                          errors?.phoneNumber
                            ? errors.phoneNumber
                            : "Enter Phone Number"
                        }
                        value={phoneNumber}
                        onChange={inputEventHandler}
                      />
                    </div>
                  </form>
                  {errorMessage && (
                    <div className="error-msg">
                      <p> {errorMessage} </p>
                    </div>
                  )}
                  <div className="login-button">
                    <Button
                      onClick={signupReqHandler}
                      isLoading={isPhoneLoading}
                      label="Continue"
                    />
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : user && !isError ? (
          <>
            <div className="process-loading-gif">
              <Lottie animationData={ProcessLottie} loop={true} />
            </div>
            <h3> Account Verification in Progress </h3>

            <p>
              Thank you for signing up with Google! We're verifying your account
              details and setting things up for you. This may take a moment.
              Please wait while we process your information. Once completed,
              you'll be redirected to your dashboard automatically.
            </p>
          </>
        ) : (
          <>
            <div className="process-loading-gif">
              <Lottie animationData={ErrorLottie} loop={true} />
            </div>
            <h3> Access Denied </h3>
            <p>
              You do not have permission to access this page. Please log in to
              continue or contact support if you believe this is a mistake
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default AuthLogin;
